import { AfterViewInit, ChangeDetectionStrategy, Component, inject, input, InputSignal, signal, WritableSignal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faArrowDown, faArrowUp, faThumbtack } from '@fortawesome/pro-light-svg-icons';
import { IconModule } from '@ogs-gmbh/ngx-m3-components';
import { HeaderOptions } from '@shared/components/table-implementation/types/column/header.type';
import { SORT_DIRECTIONS, SortDirection } from '@shared/components/table-implementation/types/sorting-directions';
import { IconName } from "@fortawesome/fontawesome-common-types";
import { Observable } from 'rxjs';

export function resolveHeaderSortDirectionToIconName (sortDirection: SortDirection): IconName | undefined {
  switch (sortDirection) {
    case SORT_DIRECTIONS.ASCENDING: {
      return "arrow-up";
    }

    case SORT_DIRECTIONS.DESCENDING: {
      return "arrow-down";
    }

    default: { return undefined; }
  }
}
export function resolveHeaderConfigToIconNames (headerConfig: HeaderOptions): IconName[] {
  const iconNames: IconName[] = [];
  const sortDirectionIconName: IconName | undefined = resolveHeaderSortDirectionToIconName(headerConfig.sortDirection);

  if (sortDirectionIconName)
    iconNames.push(sortDirectionIconName);


  return iconNames;
}
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-table-header-icon-resolver',
  standalone: true,
  imports: [ IconModule ],
  templateUrl: './table-header-icon-resolver.component.html',
  styleUrl: './table-header-icon-resolver.component.scss'
})
export class TableHeaderIconResolverComponent implements AfterViewInit {
  public headerConfig: InputSignal<HeaderOptions> = input.required<HeaderOptions>();

  private _headerConfigChange$: Observable<HeaderOptions> = toObservable(this.headerConfig);

  private faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  public resolvedIconNames: WritableSignal<IconName[]> = signal([]);

  constructor () {
    this.faIconLibrary.addIcons(faArrowUp, faArrowDown, faThumbtack);
  }

  ngAfterViewInit (): void {
    this._headerConfigChange$.subscribe((value: Readonly<HeaderOptions>) => {
      this.resolvedIconNames.set(resolveHeaderConfigToIconNames(value));
    });
  }
}
